(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["slowlines-purchase-info"] && !Shopify.designMode) return;
  try {
    import('@shopify/events').then(({ StandardEvents }) => {
  class SlowlinesPurchaseInfo extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.variants = JSON.parse(this.querySelector('[data-purchase-variants]').textContent);
      this.updateDetails(this.dataset.selectedVariantId);
      this.closest('.shopify-section')?.addEventListener(StandardEvents.productSelect, (event) => {
        const picker = event.target.closest?.('variant-picker');
        if (!picker || String(picker.dataset.productId) !== this.dataset.productId) return;
        const generation = (this.generation || 0) + 1;
        this.generation = generation;
        const dispatch = this.querySelector('.sl-purchase-info__dispatch');
        if (!dispatch) return;
        const selected = this.variants.find(v => String(v.id) === String(event.detail?.variantId));
        if (selected) {
          dispatch.hidden = !selected.available;
          dispatch.textContent = this.dispatchText(selected);
          this.updateDetails(selected.id);
          dispatch.style.visibility = '';
        } else { dispatch.hidden = false; dispatch.style.visibility = 'hidden'; }
        if (!event.promise) { dispatch.hidden = false; dispatch.style.visibility = 'hidden'; return; }
        event.promise.then(({ detail }) => {
          if (this.generation !== generation || !this.isConnected) return;
          const variant = detail?.resource;
          if (typeof variant?.available !== 'boolean') { dispatch.hidden = false; dispatch.style.visibility = 'hidden'; return; }
          const cached = this.variants.find(v => String(v.id) === String(variant.id));
          if (cached) cached.available = variant.available;
          dispatch.hidden = !variant.available;
          dispatch.textContent = this.dispatchText(variant);
          this.updateDetails(variant.id);
          dispatch.style.visibility = '';
        }).catch(() => {
          if (this.generation === generation && this.isConnected) { dispatch.hidden = false; dispatch.style.visibility = 'hidden'; }
        });
      }, { signal: this.abort.signal });
    }
    dispatchText(variant) {
      if (!variant.available) return this.dataset.unavailable;
      return String(variant.id) === this.dataset.preorderVariantId ? this.dataset.preorder : this.dataset.available;
    }
    updateDetails(variantId) {
      if (this.dataset.productId !== '10813527982419' && this.dataset.productId !== '10813528015187') return;
      const preorder = String(variantId) === this.dataset.preorderVariantId;
      const section = this.closest('.shopify-section');
      section?.querySelectorAll('[data-sl-standard-dispatch]').forEach(node => { node.hidden = preorder; });
      section?.querySelectorAll('[data-sl-preorder-dispatch]').forEach(node => { node.hidden = !preorder; });
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  if (!customElements.get('sl-purchase-info')) customElements.define('sl-purchase-info', SlowlinesPurchaseInfo);
  });
  } catch(e) { console.error(e); }
})();

})();
